import MainSection from '../../components/common/MainSection/MainSection';

const Create = () => {
  return <MainSection isEditMode={false} origin="insertionOrder" />;
};

export default Create;
